import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as packages from './PackageRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({packages: state.packages})
const connector = connect(mapState, packages.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const PackageInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(PackageInit)
